"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _dateFnsTz = require("date-fns-tz");
var _AuInput = _interopRequireDefault(require("./AuInput"));
var _AuDayPicker = _interopRequireDefault(require("./AuDayPicker"));
var _constants = require("../../constants");
var _AuPropTypes = require("../../AuPropTypes");
var _timezone = require("../../utils/timezone");
var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11; // import moment from 'moment-timezone';
var styles = {
  "container": "au_day_picker_input-module__container___tFHYe",
  "overlay": "au_day_picker_input-module__overlay___tp67r"
};
const HIDE_TIMEOUT = 100;
class AuDayPickerInput extends _react.default.Component {
  static propTypes = _AuPropTypes.AuDayPickerInputProps;
  static defaultProps = {
    value: '',
    format: 'P',
    locale: _enUS.default,
    timezone: (0, _timezone.getUserTimeZone)(),
    inputProps: {},
    dayPickerProps: {},
    showOverlay: false,
    hideOnDayClick: true,
    overlayComponent: ({
      children,
      className,
      wrapperClassName
    }) => /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.overlayWrapper, wrapperClassName)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.overlay, className)
    }, children)),
    onMonthChange: _constants.NOOP,
    onDayChange: _constants.NOOP,
    onChange: _constants.NOOP,
    onKeyUp: _constants.NOOP,
    onClick: _constants.NOOP,
    onFocus: _constants.NOOP,
    onBlur: _constants.NOOP
  };
  input = null;
  daypicker = null;
  clickedInside = false;
  clickTimeout = null;
  hideTimeout = null;
  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
    this.state.showOverlay = props.showOverlay;
  }
  componentWillUnmount() {
    clearTimeout(this.clickTimeout);
    clearTimeout(this.hideTimeout);
    clearTimeout(this.blurTimeout);
  }
  getStateFromProps(props) {
    const {
      format,
      dayPickerProps
    } = props;
    const {
      initialMonth,
      selectedDays
    } = dayPickerProps;
    let {
      value
    } = props;
    let month;
    if (value) {
      // const momentDate = moment(value);

      // if (momentDate.isValid()) {
      //   month = momentDate.toDate();
      //   value = momentDate.format(format);
      // }
      if ((0, _isValid.default)(value)) {
        // month = momentDate.toDate();
        // value = momentDate.format(format);
        month = (0, _parse.default)(value, format, new Date());
        value = (0, _format.default)(value, format);
      }
    } else {
      // Otherwise display the month coming from `dayPickerProps` or the current month
      month = initialMonth || dayPickerProps.month || new Date();
    }
    return {
      selectedDays,
      value,
      month
    };
  }
  updateState(day, value, callback) {
    const {
      dayPickerProps,
      onDayChange
    } = this.props;
    this.setState({
      month: day,
      value
    }, () => {
      if (callback) {
        callback();
      }
      if (!onDayChange) {
        return;
      }
      const modifiersObj = {
        disabled: dayPickerProps.disabledDays,
        selected: dayPickerProps.selectedDays,
        ...dayPickerProps.modifiers
      };
      // const modifiers = ModifiersUtils.getModifiersForDay(day, modifiersObj).reduce(
      //   (obj, modifier) => {
      //     const newObj = { ...obj };
      //     newObj[modifier] = true;
      //     return newObj;
      //   },
      //   {}
      // );
      const modifiers = {};
      // const modifiers = ModifiersUtils.getModifiersForDay(day, modifiersObj).reduce(
      //   (obj, modifier) => {
      //     const newObj = { ...obj };
      //     newObj[modifier] = true;
      //     return newObj;
      //   },
      //   {}
      // );
      onDayChange(day, modifiers);
    });
  }
  getInput() {
    return this.input;
  }
  getDayPicker() {
    return this.daypicker;
  }
  showDayPicker() {
    this.setState({
      showOverlay: true
    });
  }
  hideDayPicker() {
    this.setState({
      showOverlay: false
    });
  }
  hideAfterDayClick = (0, _bind.default)(_context = this.hideAfterDayClick).call(_context, this);
  hideAfterDayClick() {
    this.hideTimeout = (0, _setTimeout2.default)(() => this.hideDayPicker(), HIDE_TIMEOUT);
  }
  handleContainerMouseDown = (0, _bind.default)(_context2 = this.handleContainerMouseDown).call(_context2, this);
  handleContainerMouseDown() {
    this.clickedInside = true;
    // The input's onBlur method is called from a queue right after the onMouseDown event.
    // setTimeout adds another callback in the queue, which is called after the onBlur event.
    this.clickTimeout = (0, _setTimeout2.default)(() => {
      this.clickedInside = false;
    });
  }
  handleInputClick = (0, _bind.default)(_context3 = this.handleInputClick).call(_context3, this);
  handleInputClick(e) {
    this.showDayPicker();
    if (this.props.inputProps.onClick) {
      e.persist();
      this.props.inputProps.onClick(e);
    }
  }
  handleInputFocus = (0, _bind.default)(_context4 = this.handleInputFocus).call(_context4, this);
  handleInputFocus(e) {
    this.showDayPicker();
    if (this.props.inputProps.onFocus) {
      e.persist();
      this.props.inputProps.onFocus(e);
    }
  }
  handleInputBlur = (0, _bind.default)(_context5 = this.handleInputBlur).call(_context5, this);
  handleInputBlur(e) {
    if (this.clickedInside) {
      this.showDayPicker();
      // Force input's focus if blur event was caused by clicking inside the overlay
      this.blurTimeout = (0, _setTimeout2.default)(this.input.focus);
    } else {
      this.hideDayPicker();
    }
    if (this.props.inputProps.onBlur) {
      e.persist();
      this.props.inputProps.onBlur(e);
    }
  }
  handleInputChange = (0, _bind.default)(_context6 = this.handleInputChange).call(_context6, this);
  handleInputChange(e) {
    const {
      format,
      inputProps,
      onDayChange
    } = this.props;
    const {
      value
    } = e.target;
    if (inputProps.onChange) {
      e.persist();
      inputProps.onChange(e);
    }
    if ((0, _trim.default)(value).call(value) === '') {
      this.setState({
        value
      });
      if (onDayChange) {
        onDayChange(undefined, {});
      }
      return;
    }

    // const momentDate = moment(value, format, true);
    // if (momentDate.isValid()) {
    //   this.updateState(momentDate.toDate(), value);
    // } else {
    //   this.setState({ value });
    // }
    if ((0, _isValid.default)(value)) {
      this.updateState((0, _parse.default)(value, format, new Date()), value);
    } else {
      this.setState({
        value
      });
    }
  }
  handleInputKeyDown = (0, _bind.default)(_context7 = this.handleInputKeyDown).call(_context7, this);
  handleInputKeyDown(e) {
    // Hide the overlay if TAB key is pressed
    if (e.key === _constants.TAB_KEY) {
      this.hideDayPicker();
    }
    if (this.props.inputProps.onKeyDown) {
      e.persist();
      this.props.inputProps.onKeyDown(e);
    }
  }
  handleInputKeyUp = (0, _bind.default)(_context8 = this.handleInputKeyUp).call(_context8, this);
  handleInputKeyUp(e) {
    // Hide the overlay if the ESC key is pressed
    if (e.key === _constants.ESCAPE_KEY) {
      this.hideDayPicker();
    } else if (this.props.value === '') {
      this.showDayPicker();
    }
    if (this.props.inputProps.onKeyUp) {
      e.persist();
      this.props.inputProps.onKeyUp(e);
    }
  }
  handleMonthChange = (0, _bind.default)(_context9 = this.handleMonthChange).call(_context9, this);
  handleMonthChange(month) {
    const {
      dayPickerProps
    } = this.props;
    this.setState({
      month
    }, () => {
      if (dayPickerProps && dayPickerProps.onMonthChange) {
        dayPickerProps.onMonthChange(month);
      }
    });
  }
  handleDayClick = (0, _bind.default)(_context10 = this.handleDayClick).call(_context10, this);
  handleDayClick(day, modifiers, e) {
    const {
      dayPickerProps,
      onDayChange,
      format
    } = this.props;
    if (dayPickerProps.onDayClick) {
      dayPickerProps.onDayClick(day, modifiers, e);
    }

    // Do nothing if the day is disabled
    if (modifiers.disabled) {
      return;
    }

    // const value = moment(day).format(format);
    const value = (0, _format.default)(day, format);
    this.setState({
      value,
      month: day
    }, () => {
      if (onDayChange) {
        onDayChange(day, modifiers);
      }
      this.hideAfterDayClick();
    });
  }
  handleDayMouseEnter = (0, _bind.default)(_context11 = this.handleDayMouseEnter).call(_context11, this);
  handleDayMouseEnter(day) {
    const {
      format
    } = this.props;
    const {
      value,
      selectedDays
    } = this.state;
    const from = (0, _isArray.default)(selectedDays) && selectedDays[0];

    // if (from && moment(from).isValid() && !value && moment(day, format).isAfter(from)) {
    if (from && (0, _isValid.default)(from) && !value && (0, _isAfter.default)((0, _parse.default)(day, format, new Date()), from)) {
      this.setState({
        selectedDays: [from, {
          from,
          to: day
        }]
      });
    }
  }
  renderOverlay() {
    const {
      format,
      timezone,
      locale,
      dayPickerProps
    } = this.props;
    const {
      value,
      month
    } = this.state;
    let {
      selectedDays
    } = this.state;
    if (!selectedDays && value) {
      if ((0, _isValid.default)(value)) {
        selectedDays = (0, _dateFnsTz.toDate)(value);
      }
      // const momentDate = moment.tz(value, format, timezone);
      // if (momentDate.isValid()) {
      //   selectedDays = momentDate.toDate();
      // }
    }

    const Overlay = this.props.overlayComponent;
    return /*#__PURE__*/_react.default.createElement(Overlay, {
      classNames: this.props.overlayClassName,
      wrapperClassName: this.props.overlayWrapperClassName,
      month: month,
      selectedDay: selectedDays,
      input: this.input
    }, /*#__PURE__*/_react.default.createElement(_AuDayPicker.default, (0, _extends2.default)({}, dayPickerProps, {
      ref: el => this.daypicker = el,
      locale: locale,
      month: month,
      selectedDays: selectedDays,
      onDayClick: this.handleDayClick,
      onDayMouseEnter: this.handleDayMouseEnter,
      onMonthChange: this.handleMonthChange
    })));
  }
  render() {
    const {
      className,
      inputProps,
      createMode
    } = this.props;
    const {
      value,
      showOverlay
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className),
      onMouseDown: this.handleContainerMouseDown
    }, /*#__PURE__*/_react.default.createElement(_AuInput.default, (0, _extends2.default)({}, inputProps, {
      onMount: el => this.input = el,
      type: "text",
      value: value,
      onClick: this.handleInputClick,
      onChange: this.handleInputChange,
      onKeyDown: this.handleInputKeyDown,
      onKeyUp: this.handleInputKeyUp,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur,
      showClear: false,
      createMode: createMode
    })), showOverlay && this.renderOverlay());
  }
}
exports.default = AuDayPickerInput;